import { useNavigate } from 'react-router-dom';

import s from './LogoutButton.module.css';
import { signOutAndReset } from './sign-out';

interface LogoutButtonProps {
  /**
   * Icon-only, square, for the collapsed sidebar rail. The accessible name is
   * kept by aria-label, so the control never loses it with the visible text.
   */
  compact?: boolean;
}

export function LogoutButton({ compact = false }: LogoutButtonProps): JSX.Element {
  const navigate = useNavigate();

  async function handleLogout(): Promise<void> {
    await signOutAndReset();
    navigate('/login', { replace: true });
  }

  return (
    <button
      type="button"
      className={compact ? `${s.root} ${s.compact}` : s.root}
      aria-label="Log out"
      title="Log out"
      onClick={() => {
        void handleLogout();
      }}
    >
      {/* A 16-unit glyph padded out to a 20-unit box, so it occupies the same
          square as NavIcon in the list above and the labels line up — without
          scaling the artwork, which would thicken the stroke past theirs. */}
      <svg
        className={s.icon}
        viewBox="-2 -2 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M10 11.5 13.5 8 10 4.5M13.5 8H6M9 1.5H3.5A1.5 1.5 0 0 0 2 3v10a1.5 1.5 0 0 0 1.5 1.5H9" />
      </svg>
      <span className={s.label}>Log out</span>
    </button>
  );
}
